import { HTTPError } from 'ky';

import type { USER_ROLE } from '@/entities/user/constants';
import { type User, type UserWorkspace } from '@/entities/user/types';
import { socialApiClient } from '@/shared/api-client/social-api-client';

export async function fetchUser(): Promise<User> {
  try {
    const response = await socialApiClient.get<{
      id: string;
      email: string;
      first_name: string;
      last_name: string;
      role: USER_ROLE;
      workspaces: UserWorkspace[];
    }>('users/me');
    const data = await response.json();
    return {
      id: data.id,
      email: data.email,
      first_name: data.first_name,
      last_name: data.last_name,
      workspaces: data.workspaces,
    };
  } catch (error) {
    // If we get a 401 during workspace creation, clear the workspace creation cache
    if (error instanceof HTTPError && error.response.status === 401) {
      // Check if we're in workspace creation flow by looking for the storage key
      const workspaceCreationData = localStorage.getItem('workspaceCreation');
      if (workspaceCreationData) {
        // Clear workspace creation cache
        localStorage.removeItem('workspaceCreation');
      }
    }
    throw error;
  }
}
